import api from "../api";
import { masonCtlKey } from "../api";
import { AxiosRequestConfig } from "axios";
import MasonDocument from "lib/mason";
import { CursorServicePayload } from "lib/api/types";

// API path
const path = "cursor";

type CreateCursorPayload = CursorServicePayload;

/**
 * Create a new cursor
 *
 * @param data params for creating the cursor - filters, sort options...
 * @param opts optional axios request config
 */
const create = async (data: CreateCursorPayload, opts?: AxiosRequestConfig) => {
	const cursor = await api.request({
		url: path,
		method: "POST",
		data,
		...opts,
	});
	return nextPage(cursor.data.id, data["page-size"]);
};

/**
 * Defines a row of data returned by the cursor service
 */
export type CursorDataRow = {
	id: string;
	version: string;
	"@controls": unknown;
	data: { [k: string]: unknown };
};

export type CursorResults = CursorDataRow[];

export type CursorPageResponseData = {
	cursorId: string;
	hasMore: boolean;
	results: CursorResults;
};

/**
 * Move the cursor forward to the next set of items
 *
 * @param cursorId the cursor id
 * @param count the number of items to move forward by
 */
const nextPage = async (
	cursorId: string,
	count = 10
): Promise<CursorPageResponseData> => {
	const res = await api.request({
		url: `${path}/${cursorId}`,
		method: "POST",
		data: {
			count,
			direction: "forward",
		},
	});

	return {
		cursorId,
		hasMore: MasonDocument.hasControl(
			res.data,
			masonCtlKey.cursor.moveForward
		),
		results: res.data.matches as CursorResults,
	};
};

// const prevPage = () => {};

// const deleteCursor = (id: string) => {}

export default {
	create,
	nextPage,
};
